/**
 * merchant-intake routes. Paths are the public contract; keep them exact.
 */

import { Route } from 'react-router-dom';

import { IntakeLineRedirect, MerchantProfileRoute } from './LandingPage.js';
import { LandingRoute } from './LandingRoute.js';
import { ProductionLineSetupPage } from './ProductionLineSetupPage.js';

/**
 * Routes reachable before sign-in: the landing page and the intake preview.
 * `/` renders the deployment's landing variant — the full landing page or
 * the Coming Soon page — see `LandingRoute.tsx`.
 */
export function merchantIntakePublicRoutes() {
  return (
    <>
      <Route path="/" element={<LandingRoute />} />
      <Route path="/business-profile" element={<MerchantProfileRoute />} />
    </>
  );
}

/**
 * Intake-scoped continuations the server still hands out; composed inside
 * the merchant workspace shell, which resolves them to the Production Line
 * behind the intake.
 */
export function merchantIntakeShellRoutes() {
  return (
    <>
      <Route
        path="/merchant/intakes/:intakeId/production-lines/new"
        element={<ProductionLineSetupPage />}
      />
      <Route path="/merchant/intakes/:intakeId" element={<IntakeLineRedirect />} />
      <Route
        path="/merchant/intakes/:intakeId/recommendations"
        element={<IntakeLineRedirect />}
      />
    </>
  );
}
